export default __webpack_public_path__ + "static/12dprinter-6ee8e761c484a86a87e5a99f2cb74d7c.jpg";